import React, { useEffect, useState, useTransition } from "react";
import { useNavigate, useParams } from "react-router-dom";
import * as API from "../../framework/API/api";
import { utility } from "../../framework/utility/utilityProvider";
import { EditPageHeader } from "../../components/EditPageHeader";
import { Button } from "react-bootstrap";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import RoundButton from "../../framework/forms/helpercomponents/buttons/RoundButton";
import { Grid, GridColumn } from "@progress/kendo-react-grid";
import { ImageCell } from "../../framework/forms/helpercomponents/CustomGridCells/ImageCell";
import { useTranslation } from "../../locale/useTranslation";
import { ENTITYNAME, LOCALSTORAGE_KEY, TOAST_TYPES } from "../../framework/constant/constant";
import AddRoundButton from "../../framework/forms/helpercomponents/buttons/AddRoundButton";
import { uploadFileS3 } from "../AWS/awsHelper";
import ToastNotification from "../../components/ToastNotification";

const SMAdEditForm = ({onClose, item, onSaveData}) => {

    const lang = useTranslation();

    const { SID } = useParams();
    const navigate = useNavigate();

    const blankDataItem = {
        ...item,
        assetId: item?.assetId ?? '',
        title: item?.title ?? '',
        description: item?.description ?? '',
        product: item?.product ?? {},
        brand: item?.brand ?? {},
        creatives: item?.creatives ?? [],
    };

    const [dataItem, setDataItem] = useState(blankDataItem);
    const [products, setProducts] = useState([]);
    const [brands, setBrands] = useState([]);
    const [selectedFiles, setSelectedFiles] = useState([]); // new files
    const [isLoading, setIsLoading] = useState(false);
    const [displayFiles, setDisplayFiles] = useState([]);

    useEffect(() => {
        loadCombo();
        if (SID) loadData();
    }, []);

    const loadCombo = async () => {
        let productRes = await API.getDataLookup(ENTITYNAME.Product);
        setProducts(productRes.data);
        let brandRes = await API.getDataLookup(ENTITYNAME.Brand);
        setBrands(brandRes.data);

        if (!SID) {
            setDataItem(prev => ({
                ...prev,
                product: utility.getDefaultItem(productRes.data),
                brand: utility.getDefaultItem(brandRes.data)
            }));
        }
    };

    const loadData = async () => {
        let res = await API.getEntity(ENTITYNAME.SM_Ads, parseInt(SID));
        if (res.success) {
            let data = res?.data ?? {};
            const updatedCreatives = data.creatives?.length > 0 ? data?.creatives?.map(att => ({
                ...att,
                isUploaded: true
            })) : [];
            setDataItem({ ...data, creatives: updatedCreatives });
        } else {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: res?.message });
        }
    };


    const onChange = (e) => {
        const { name, value } = e.target;
        setDataItem({ ...dataItem, [name]: value });
    };

    const onFileChange = (e) => {
        const files = Array.from(e.target.files);
        const existingNames = [
            ...dataItem.creatives.map(att => att.fileName),
            ...selectedFiles.map(f => f.file?.name || f.name)
        ];

        const newFiles = files.filter(file => {
            if (existingNames.includes(file.name)) {
                ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.file_already_attached_error_message });
                return false;
            }
            return true;
        }).map(file => ({
            file,
            isUploaded: false,
            fileName: file.name,
            format: file.name.split('.').pop()
        }));

        setSelectedFiles(prev => [...prev, ...newFiles]);
        e.target.value = '';
    };

    const handleDelete = (file, index, isNewFile) => {
        if (isNewFile) {
            setSelectedFiles(prev => prev.filter((_, i) => i !== index));
        } else {
            setDataItem(prev => ({
                ...prev,
                creatives: prev.creatives.filter((_, i) => i !== index)
            }));
        }
    };

    // const handleDelete = (file, index, isNewFile) => {
    //     const existingLength = dataItem.creatives.length;
    //     if (isNewFile) {
    //         // setSelectedFiles(prev => prev.filter((_, i) => i !== index));
    //         const adjustedIndex = index - existingLength;

    //         setSelectedFiles(prev => prev.filter((_, i) => i !== adjustedIndex));
    //         // setSelectedFiles(prev => prev.filter((_, i) => i !== index));
    //     } else {
    //         setDataItem(prev => ({
    //             ...prev,
    //             creatives: prev.creatives.filter((_, i) => i !== index)
    //         }));
    //     }
    // };

    const handleCancel = () => {
        if (onClose){ onClose();  } 
        else { navigate(-1); }
      };

    const MyCommandCell = (cell) => {
        return <td>
            <RoundButton icon="trash" Title={lang.delete_button_tooltip} onClick={() => handleDelete(cell.dataItem, cell.dataIndex, cell.dataItem._source === 'new')} />
        </td>
    }

    const isValid = () => {
        if (!dataItem.assetId || dataItem.assetId === "") {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_enter_asset_id_error_message })
            return false;
        }
        if (!dataItem.title || dataItem.title === "") {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_enter_title_error_message })
            return false;
        }
        if (!dataItem.product || Object.keys(dataItem.product).length == 0) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_product_error_message })
            return false;
        }
        if (!dataItem.brand || Object.keys(dataItem.brand).length == 0) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_brand_error_message })
            return false;
        }
        const totalAttachments = dataItem.creatives.length + selectedFiles.length;
        if (totalAttachments === 0) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_attach_at_least_one_asset_error_message })
            return false;
        }
        return true;
    };

    const handleSubmit = async (e) => {
        if (!isValid()) return;
        setIsLoading(true);
    
        const uploadedCreatives = [];
    
        for (let i = 0; i < selectedFiles.length; i++) {
            const fileObj = selectedFiles[i];
            const file = fileObj?.file;
    
            if (!file || fileObj?.public_id || fileObj?.isUploaded) continue;
    
            let uploadRes;
            const isVideo = file.type?.startsWith('video/') || /\.(mp4|mov|avi|mkv)$/i.test(file.name);
    
            try {
                if (isVideo) {
                    const credential = utility.getValue(LOCALSTORAGE_KEY.INSTANCE)?.StorageCredentials?.BossCloudMedia ?? {};
                    const company = utility.getValue(LOCALSTORAGE_KEY.COMPANY);
    
                    uploadRes = await uploadFileS3(file, credential, (progress) => {
                        setDisplayFiles(prev => {
                            const updated = [...prev];
                            updated[i] = { ...updated[i], progress, percentage: `${progress}%` };
                            return updated;
                        });
                    }, company);
                } else {
                    // Simulate instant progress for images
                    setDisplayFiles(prev => {
                        const updated = [...prev];
                        updated[i] = { ...updated[i], progress: 100, percentage: '100%' };
                        return updated;
                    });
    
                    uploadRes = await API.uploadImage(file);
                }
    
                console.log(uploadRes);
    
                const result = isVideo ? uploadRes?.data : uploadRes?.result;
    
                if (uploadRes?.success && result) {
                    uploadedCreatives.push({
                        asset_id: result.asset_id,
                        public_id: result.public_id,
                        url: result.secure_url,
                        thumbnailUrl: result.thumbnailUrl || result.secure_url,
                        fileName: file.name,
                        format: file.name.split('.').pop(),
                        isUploaded: true
                    });
                } else {
                    ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: uploadRes?.message || 'Upload failed' });
                }
            } catch (err) {
                console.error('Upload error:', err);
                ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: 'Unexpected upload error' });
            }
        }
    
        const finalData = {
            _id: dataItem._id,
            assetId: dataItem.assetId,
            title: dataItem.title,
            description: dataItem.description,
            product: {
                _id: dataItem.product._id,
                Name: dataItem.product.Name
            },
            brand: {
                _id: dataItem.brand._id,
                Name: dataItem.brand.Name
            },
            creatives: [...dataItem.creatives, ...uploadedCreatives],
            checkDuplicate: true,
            query: [["assetId", "=", dataItem.assetId]],
        };
    
        console.log('Final Data:', finalData);
    
        try {
            const res = await API.saveData(ENTITYNAME.SM_Ads, finalData);
    
            if (res.success) {
                utility.deleteLocalStorageItem(ENTITYNAME.SM_Ads);
                handleCancel();
                onSaveData && onSaveData(res.data);
            } else {
                ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: res.message });
            }
        } catch (err) {
            console.error('Save error:', err);
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: 'Unexpected save error' });
        } finally {
            setIsLoading(false);
        }
    };    
    
    return (
        <div className="p-2">
            <EditPageHeader isLoading={isLoading} title={lang.ad_dialog_header} onSubmit={handleSubmit} onCancel={handleCancel} headerTitle={lang.ad_dialog_header} />
            <div className="row mt-2">
                <div className="col-4 form-group">
                    <label htmlFor="assetId">{lang.asset_id_label} *</label>
                    <input type="text" name="assetId" placeholder="Enter Asset ID" className="form-control form-control-sm" value={dataItem.assetId} onChange={onChange} />
                </div>
                <div className="col-4 form-group">
                    <label htmlFor="title">{lang.title_label} *</label>
                    <input type="text" name="title" placeholder="Enter Title" className="form-control form-control-sm" value={dataItem.title} onChange={onChange} />
                </div>
                <div className="col-4 form-group">
                    <label htmlFor="description">{lang.description_label} </label>
                    <input type="text" name="description" placeholder="Enter Description" className="form-control form-control-sm" value={dataItem.description} onChange={onChange} />
                </div>
            </div>
            <div className="row mt-2">
                <div className="col-4 form-group">
                    <label htmlFor="product">{lang.product_label} *</label>
                    <DropDownList
                        name="product"
                        textField="Name"
                        dataItemKey="_id"
                        className="bg-white"
                        data={products}
                        value={dataItem.product}
                        onChange={onChange}
                    />
                </div>
                <div className="col-4 form-group">
                    <label htmlFor="brand">{lang.brand_label} *</label>
                    <DropDownList
                        name="brand"
                        textField="Name"
                        dataItemKey="_id"
                        className="bg-white"
                        data={brands}
                        value={dataItem.brand}
                        onChange={onChange}
                    />
                </div>
            </div>
            <div className="row mt-2 p-2">
                <div className="flex items-center ml-2">
                    <AddRoundButton
                        name="Attach Assets"
                        onClick={() => document.getElementById('fileInput').click()}
                        title="Add"
                        icon="plus"
                    />
                    <input
                        type="file"
                        id="fileInput"
                        name="creatives"
                        multiple
                        onChange={onFileChange}
                        style={{ display: 'none' }}
                    />
                </div>
            </div>

            <div className="p-2">
                <Grid
                    style={{ height: "50vh", marginTop: "1px" }}
                    data={[
                        ...dataItem.creatives.map((file, i) => ({
                            ...file,
                            _source: 'existing',
                            _index: i,
                            isUploaded: true
                        })),
                        ...selectedFiles.map((fileObj, i) => ({
                            ...fileObj,
                            _source: 'new',
                            _index: i,
                            isUploaded: false
                        }))
                    ]}
                >
                    {/* <GridColumn editable={false} cell={MyCommandCell} width={"60px"} /> */}
                    <GridColumn field='url' title={lang.image_column} width={"100px"} cell={(props) => <ImageCell {...props} />} />
                    <GridColumn field='fileName' title={lang.file_name_column} />
                    <GridColumn field='format' title={lang.format_column} cell={({ dataItem }) => (
                        <td>
                            <div style={{ display: 'flex', alignItems: 'center', height: '100%', textAlign: 'left' }}>
                                {dataItem && dataItem.format ? dataItem.format.toUpperCase() : ''}
                            </div>
                        </td>
                    )}
                    />

                </Grid>
            </div>
        </div>
    );
};

export default SMAdEditForm;